/// <reference path="navigationService.d.ts" />

declare var LtFramework: lt.Static;
declare var lt: {
	globalPageDrivers: {
		account: {
			[key: string]: string
		},
		global: {
			[key: string]: string
		}
	},
	api: {

		account: string
	}
};

class NavigationService implements INavigationService {

	public static $inject: string[] = ['$q', '$window'];

	private readonly $q: ng.IQService;
	private readonly $window: ng.IWindowService;

	constructor($q: ng.IQService, $window: ng.IWindowService) {
		this.$q = $q;
		this.$window = $window;
	}

	public resolveDestination(destinationKey: string, parameters: {[key: string]: string} = {}): string | undefined {
		// tslint:disable-next-line: strict-type-predicates
		const pdExists = typeof(lt) !== 'undefined' && typeof(lt.globalPageDrivers) !== 'undefined' && lt.globalPageDrivers != null;

		if (!pdExists || !destinationKey) {
			return undefined;
		}

		let url: string;
		if (destinationKey.indexOf('account.') === 0) {
			url = lt.globalPageDrivers.account[destinationKey.substr(8)];
		} else if (destinationKey.indexOf('global.') === 0) {
			url = lt.globalPageDrivers.global[destinationKey.substr(7)];
		} else {
			// default to account
			url = lt.globalPageDrivers.account[destinationKey];
		}

		if (parameters && Object.keys(parameters).length) {
			url += '?';

			let first = true;
			Object.keys(parameters).forEach((key: string) => {
				let delim = '';

				if (first) {
					first = false;
				} else {
					delim = '&';
				}

				url += `${delim}${key}=${encodeURI(parameters[key])}`;
			});
		}

		return url;
	}

	public requestNavigation(destination: string, parameters: {[key: string]: string} = {}, targetBlank = false): ng.IPromise<void> {
		const dfd = this.$q.defer<void>();

		const url = this.resolveDestination(destination, parameters);

		if (!url) {
			dfd.reject(new Error(`Page Driver ${destination} does not exist.`));
			return dfd.promise;
		}

		if (targetBlank) {
			this.$window.open(url, '_blank');
		} else {
			this.$window.location.href = url;
		}

		dfd.resolve();

		return dfd.promise;
	}
}

export default NavigationService;
